// extracted by mini-css-extract-plugin
export default {"recommendationsSpacing":"Recommendations_recommendationsSpacing__6AOJH","title":"Recommendations_title__SVN5u","slide":"Recommendations_slide__ICfXp"};